import { createFileRoute, Outlet } from '@tanstack/react-router'
import { requireModule, requirePermission } from '../../../app/guards'

export const Route = createFileRoute('/_app/service')({
  beforeLoad: ({ context }) => {
    requireModule(context.session, 'service')
    requirePermission(context.session, 'service.read')
  },
  component: Outlet,
})
